import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useI18n } from "@/lib/i18n";
import { imgUrl } from "@/lib/api";

export const Story = ({ photo }) => {
  const { t } = useI18n();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  if (!photo) return null;
  return (
    <section ref={ref} data-testid="story-section" className="relative h-[80svh] min-h-[520px] overflow-hidden bg-ink">
      <motion.img style={{ y, scale: 1.25 }} src={imgUrl(photo.url)} alt={photo.caption || ""} className="absolute inset-0 h-full w-full object-cover opacity-70" />
      <div className="absolute inset-0 bg-gradient-to-t from-deep/90 via-deep/40 to-transparent" />
      <div className="relative mx-auto flex h-full max-w-[1280px] items-end px-5 pb-16 sm:px-8 sm:pb-24">
        <blockquote className="max-w-4xl">
          <p data-testid="story-quote" className="font-display text-4xl italic leading-[1.05] text-paper sm:text-6xl lg:text-7xl">“{t("story")}”</p>
          <footer className="mt-6 font-mono text-xs uppercase tracking-[0.3em] text-gold">— {t("storyBy")}</footer>
        </blockquote>
      </div>
    </section>
  );
};
